/**
 * 统一社会信用代码校验（GB 32100-2015）
 * @param {string} code - 统一社会信用代码
 * @returns {boolean} 校验结果
 */
export function checkUnifiedSocialCreditCode(code) {
  if (!code || typeof code !== 'string') return false

  // 格式化：去空格 + 转大写
  const value = code.trim().toUpperCase()

  // 1. 正则格式校验（严格国标，排除 I/O/S/V/Z 共 5 个字母）
  const reg = /^[159Y][1239][0-9]{6}[0-9A-HJ-NP-RT-UW-Y]{9}[0-9A-HJ-NP-RT-UW-Y]$/
  if (!reg.test(value)) return false

  // 2. 国标校验码验证
  const chars = '0123456789ABCDEFGHJKLMNPQRTUWXY'
  const weights = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]

  let sum = 0
  for (let i = 0; i < 17; i++) {
    const index = chars.indexOf(value[i])
    if (index === -1) return false
    sum += index * weights[i]
  }

  const mod = sum % 31
  const checkCode = mod === 0 ? '0' : chars[31 - mod]

  return checkCode === value[17]
}

/**
 * 仅正则格式校验（不校验校验码）
 * @param {string} code
 * @returns {boolean}
 */
export function checkCreditCodeFormat(code) {
  if (!code) return false
  const reg = /^[159Y][1239][0-9]{6}[0-9A-HJ-NP-RT-UW-Y]{9}[0-9A-HJ-NP-RT-UW-Y]$/
  return reg.test(code.trim().toUpperCase())
}